<script setup lang="ts">
import { useElementId } from '../../common/composables/useElementId';
import { Textarea } from 'primevue';

const props = defineProps<{
  title: string;
  change: boolean;
}>();

const modelValue = defineModel<string|undefined>({ required: true});
const elementId = useElementId();

</script>

<template>
  <div class="field" :class="{ changed: props.change }">
    <label :for="elementId">{{ props.title }}</label>
    <Textarea autocomplete="off" v-model:modelValue="modelValue" :id="elementId"></Textarea>
  </div>
</template>
